import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAgenda = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 41,
	height: 38,
	viewBox: "0 0 41 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_465_3200)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 5,
				y: 5,
				width: 31,
				height: 28,
				rx: 5,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 14,
			x2: 27,
			y2: 14,
			stroke: "#625fe3"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 18.5,
			x2: 27,
			y2: 18.5,
			stroke: "#625fe3"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 23.5,
			x2: 27,
			y2: 23.5,
			stroke: "#625fe3"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 1,
			fill: "#464646"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 18.5,
			r: 1,
			fill: "#464646"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 23.5,
			r: 1,
			fill: "#464646"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_465_3200",
			x: 0,
			y: 0,
			width: 41,
			height: 38,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.5 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_465_3200"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_465_3200",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgAgenda;
